<template>
  <div class="relative w-35px" @click="$emit('click')">
    <p class="text-skin-blueCambiando text-sm font-bold items-qty">
      {{ carShop.length }}
    </p>
    <ShoppingCart />
  </div>
</template>

<script>
import ShoppingCart from "./icons/ShoppingCart.vue";
import { mapGetters } from "vuex";
export default {
  components: { ShoppingCart },
  computed: {
    ...mapGetters({
      carShop: "shopingCart/getCart",
    }),
  },
};
</script>

<style scoped>
.items-qty {
  position: absolute;
  top: -15px;
  right: 16px;
}
</style>
